module.exports = __webpack_public_path__ + "static/media/signal.3ba2108d.png";